import { normalize } from 'normalizr';
import { arrayOfVideos } from 'shared/schemas';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';

import vodAdapter from 'shared/utils/adapters/vod';

import { getChannelVideoIds } from 'shared/selectors/channel-videos';
import getPositionData from 'shared/redux/helpers/position-data';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEOS.ADD');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


function normalizeData(data) {
  return normalize(data, arrayOfVideos);
}


export default function (id, videoIds, atIndex = 0) {
  return function (dispatch, getState) {
    if (videoIds.length === 0) {
      return Promise.resolve();
    }

    let positionData = {};
    if (atIndex !== 0) {
      const channelVideos = getChannelVideoIds(getState());
      positionData = getPositionData(channelVideos, atIndex);
    }

    const params = { id, videoIds, atIndex };
    dispatch(START(params));

    const promise = vodAdapter.listItems.add(id, videoIds, positionData);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeData(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'dashboard.channel.videos.add' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/channel/videos/add.js